module.exports = __webpack_public_path__ + "a67f746052637623f5a49b69a9a411de.svg";